import { KeyboardEvent, useState } from "react";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";

import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchMonthSingleForm } from "src/components/common/form/search/SearchMonthSingleForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { formatDateMonth, formatDateYear4 } from "src/utils/string/stringUtil";
import { useEQM2050_R01Store } from "./Store_EQM2050_R01";

interface Props {
  onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
  onForm18PdfClick: () => void;
  onForm7PdfClick: () => void;
}

export const SearchSection_EQM2050_R01 = ({ onEnterKeyDown, onForm18PdfClick, onForm7PdfClick }: Props) => {

	const { EQM2050_R01Filter, setEQM2050_R01Filter } = useEQM2050_R01Store();
	const { compCdList, yesNoList } = useCommonCodeStore();
	
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

  return (
    <SearchSectionForm>
		<SearchDropDownForm
			label="사업장"
			value={EQM2050_R01Filter.compCd}
			optionList={compCdList}
			onChangeItem={(selectedItem) => setEQM2050_R01Filter({ compCd: selectedItem?.compCd || '' })}
		/>
		
		<SearchMonthSingleForm
				label="생산년월"
				visible={pickerVisible}		setVisible={setPickerVisible}
				value={new Date(EQM2050_R01Filter.inspectionMonth)}
				editable={true}
				onChange={(date) => setEQM2050_R01Filter({ inspectionMonth: formatDateYear4(date)+'-'+formatDateMonth(date) })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>

			<button
				onClick={onForm18PdfClick}
				className="flex-shrink-0 bg-white hover:bg-gray-100 border border-gray-300 text-gray-800 font-semibold px-4 rounded shadow h-[30px]"
			>
				폐수배출시설서식
			</button>
			<button
				onClick={onForm7PdfClick}
				className="flex-shrink-0 bg-white hover:bg-gray-100 border border-gray-300 text-gray-800 font-semibold px-4 rounded shadow h-[30px]"
			>
				대기배출시설서식
			</button>
	</SearchSectionForm>
  );
};